import PropTypes from "prop-types";
import { TextField, InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";
import { useRewampT } from "../../../localisation";
import { dropdownPartSx } from "../../../design/recipes/dropdown";

export default function FilterLocalSearchField({
  controlId,
  labelKey,
  label,
  placeholderKey,
  placeholder,
  ariaLabelKey,
  ariaLabel,
  iconColor,
  value,
  onChange,
  dropdownVariant,
  inputProps,
  onFocus,
  onBlur,
  onKeyDown,
}) {
  const tRewamp = useRewampT();
  const triggerSx = dropdownPartSx(dropdownVariant, "trigger");
  const resolvedLabel = label || (labelKey ? tRewamp(labelKey) : undefined);
  const resolvedPlaceholder = placeholder || (placeholderKey ? tRewamp(placeholderKey) : undefined);
  const resolvedAriaLabel = ariaLabel || (ariaLabelKey ? tRewamp(ariaLabelKey) : undefined);

  return (
    <TextField
      id={controlId}
      variant="outlined"
      size="small"
      fullWidth
      label={resolvedLabel}
      placeholder={resolvedPlaceholder}
      inputProps={{ "aria-label": resolvedAriaLabel, ...inputProps }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      sx={triggerSx ? { "& .MuiOutlinedInput-root": triggerSx, "& .MuiInputAdornment-positionStart": { mr: 1 } } : undefined}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search sx={{ color: iconColor }} />
          </InputAdornment>
        ),
      }}
    />
  );
}

FilterLocalSearchField.propTypes = {
  controlId: PropTypes.string,
  labelKey: PropTypes.string,
  label: PropTypes.string,
  placeholderKey: PropTypes.string,
  placeholder: PropTypes.string,
  ariaLabelKey: PropTypes.string,
  ariaLabel: PropTypes.string,
  iconColor: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  dropdownVariant: PropTypes.string,
  inputProps: PropTypes.object,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
};

FilterLocalSearchField.defaultProps = {
  dropdownVariant: undefined,
  controlId: undefined,
  labelKey: null,
  label: null,
  placeholderKey: null,
  placeholder: null,
  ariaLabelKey: null,
  ariaLabel: null,
  iconColor: "text.secondary",
  inputProps: undefined,
  onFocus: undefined,
  onBlur: undefined,
  onKeyDown: undefined,
};
